import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from "@fluentui/react-components";
import { Dropdown } from "../../primitives/dropdown";
import { PropertyLine } from "./propertyLine";
import { forwardRef } from "react";
import { UniformWidthStyling } from "../../primitives/utils";
const useStyles = makeStyles({
    dropdown: {
        ...UniformWidthStyling,
    },
});
/**
 * Wraps a dropdown in a property line
 * @param props - PropertyLineProps and DropdownProps
 * @returns property-line wrapped dropdown
 */
export const DropdownPropertyLine = forwardRef((props, ref) => {
    DropdownPropertyLine.displayName = "DropdownPropertyLine";
    const classes = useStyles();
    return (_jsx(PropertyLine, { ...props, ref: ref, children: _jsx(Dropdown, { ...props, className: classes.dropdown }) }));
});
/**
 * Dropdown component for number values.
 */
export const NumberDropdownPropertyLine = DropdownPropertyLine;
/**
 * Dropdown component for string values
 */
export const StringDropdownPropertyLine = DropdownPropertyLine;
//# sourceMappingURL=dropdownPropertyLine.js.map